import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import ProcessListResults from 'components/Processes/ProcessListResults';

const mapStateToProps = (state) => ({
  products: state.products,
  vendors: state.vendors,
  salesOrders: state.salesOrders,
  processes: state.processes,
  user: state.user
});

const ProcessList = (props) => (
  <>
    <Helmet>
      <title>Processes | Duot Khayat</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <ProcessListResults
          products={props.products}
          vendors={props.vendors}
          salesOrders={props.salesOrders}
          processes={props.processes}
          user={props.user}
        />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (ProcessList);